var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _g1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 104,
    viewBox: "0 0 47 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13751_185692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13751_185692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V104H47V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3745 102.981C45.4558 102.981 44.5381 102.632 43.8383 101.933L12.0194 70.114C11.342 69.4366 10.9688 68.536 10.9688 67.5778C10.9688 66.6197 11.342 65.719 12.0194 65.0416L24.3165 52.7445C24.9939 52.0671 25.8946 51.6939 26.8527 51.6939C27.8108 51.6939 28.7115 52.0671 29.3889 52.7445L61.2079 84.5635C62.6062 85.9618 62.6062 88.2375 61.2079 89.6359L48.9107 101.933C48.211 102.633 47.2922 102.981 46.3745 102.981ZM44.7401 101.03C45.6408 101.931 47.1072 101.931 48.0079 101.03L60.305 88.733C61.2057 87.8323 61.2057 86.3659 60.305 85.4652L28.4871 53.6473C28.0511 53.2113 27.4705 52.971 26.8538 52.971C26.237 52.971 25.6564 53.2113 25.2204 53.6473L12.9222 65.9445C12.4862 66.3804 12.2459 66.9611 12.2459 67.5778C12.2459 68.1946 12.4862 68.7752 12.9222 69.2112L44.7401 101.03Z",
    fill: "#AEB6FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13751_185692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V104H47V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6123 134.139C32.6935 134.139 31.7758 133.789 31.0761 133.091L12.3975 114.412C10.9992 113.014 10.9992 110.738 12.3975 109.34L24.969 96.7681C25.6464 96.0907 26.5471 95.7175 27.5052 95.7175C28.4633 95.7175 29.364 96.0907 30.0414 96.7681L48.72 115.447C50.1183 116.845 50.1183 119.121 48.72 120.519L36.1485 133.091C35.4488 133.789 34.53 134.139 33.6123 134.139ZM27.5041 96.9946C26.8874 96.9946 26.3067 97.2349 25.8708 97.6709L13.2993 110.242C12.3986 111.143 12.3986 112.61 13.2993 113.51L31.9778 132.189C32.8785 133.089 34.345 133.089 35.2457 132.189L47.8171 119.617C48.7178 118.717 48.7178 117.25 47.8171 116.349L29.1386 97.6709C28.7015 97.2349 28.122 96.9946 27.5041 96.9946Z",
    fill: "#AEB6FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13751_185692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V104H47V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.89392 92.7761C-8.72337 92.7761 -9.55281 92.4603 -10.1845 91.8286C-11.4478 90.5653 -11.4478 88.5098 -10.1845 87.2465L2.87616 74.1858C4.13947 72.9225 6.19502 72.9225 7.45833 74.1858C8.72165 75.4491 8.72165 77.5047 7.45833 78.768L-5.6023 91.8286C-6.23396 92.4603 -7.06447 92.7761 -7.89392 92.7761ZM5.16778 74.5133C4.66479 74.5133 4.16181 74.7048 3.77899 75.0876L-9.28271 88.1493C-10.0484 88.9149 -10.0484 90.1612 -9.28271 90.9269C-8.51707 91.6925 -7.27077 91.6925 -6.50512 90.9269L6.55551 77.8662C7.32116 77.1006 7.32116 75.8543 6.55551 75.0887C6.17269 74.7048 5.6697 74.5133 5.16778 74.5133Z",
    fill: "#AEB6FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13751_185692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V104H47V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0162 38.1221C16.0974 38.1221 15.1797 37.7722 14.48 37.0736L-17.3379 5.2557L-16.4351 4.35287L15.3839 36.1718C16.2846 37.0725 17.751 37.0725 18.6517 36.1718L26.2635 28.559L27.1663 29.4618L19.5545 37.0746C18.8537 37.7733 17.935 38.1221 17.0162 38.1221Z",
    fill: "#AEB6FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_13751_185692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V104H47V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31.9007 87.0378C-32.8195 87.0378 -33.7372 86.6879 -34.4369 85.9893L-66.2548 54.1714C-66.9322 53.494 -67.3054 52.5933 -67.3054 51.6352C-67.3054 50.6771 -66.9322 49.7764 -66.2548 49.099L-29.5899 12.4342C-28.1916 11.0358 -25.9159 11.0358 -24.5175 12.4342L7.30141 44.2531C8.69978 45.6515 8.69978 47.9271 7.30141 49.3255L-29.3645 85.9893C-30.0631 86.689 -30.9819 87.0378 -31.9007 87.0378ZM-33.5341 85.0875C-32.6334 85.9882 -31.167 85.9882 -30.2663 85.0875L6.39859 48.4227C7.29929 47.522 7.29929 46.0556 6.39859 45.1549L-25.4204 13.337C-26.3211 12.4363 -27.7875 12.4363 -28.6882 13.337L-65.353 50.0008C-65.789 50.4368 -66.0293 51.0174 -66.0293 51.6341C-66.0293 52.2509 -65.789 52.8315 -65.353 53.2675L-33.5341 85.0875Z",
    fill: "#AEB6FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_13751_185692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V104H47V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4097 6.38051C44.4144 6.38051 48.1799 7.94051 51.0117 10.7713L51.352 11.1116C54.1838 13.9434 55.7438 17.7089 55.7438 21.7136C55.7438 25.7184 54.1838 29.4839 51.352 32.3157L40.75 42.9177L29.8076 31.9754C26.9758 29.1436 25.4158 25.3781 25.4158 21.3733C25.4158 17.3686 26.9758 13.6031 29.8076 10.7713C32.6405 7.93945 36.4049 6.38051 40.4097 6.38051ZM40.666 32.2902C46.5455 32.2902 51.3286 27.507 51.3286 21.6275C51.3286 15.748 46.5455 10.9648 40.666 10.9648C34.7864 10.9648 30.0033 15.748 30.0033 21.6275C30.0033 27.5081 34.7864 32.2902 40.666 32.2902ZM40.4097 5.10443C36.2465 5.10443 32.0822 6.69315 28.9058 9.86951C22.5521 16.2233 22.5521 26.5244 28.9058 32.8772L40.751 44.7223L52.2548 33.2185C58.6086 26.8647 58.6086 16.5636 52.2548 10.2109L51.9146 9.87057C48.7371 6.69208 44.5739 5.10443 40.4097 5.10443ZM40.666 31.0141C35.4819 31.0141 31.2793 26.8115 31.2793 21.6275C31.2793 16.4434 35.4819 12.2409 40.666 12.2409C45.85 12.2409 50.0525 16.4434 50.0525 21.6275C50.0525 26.8115 45.85 31.0141 40.666 31.0141Z",
    fill: "#AEB6FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_13751_185692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V104H47V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12.4735 80.1258C-12.6372 80.1258 -12.7999 80.0631 -12.9243 79.9387C-13.1732 79.6898 -13.1732 79.2857 -12.9243 79.0358L-11.8365 77.948C-11.5876 77.6992 -11.1836 77.6992 -10.9337 77.948C-10.6848 78.1968 -10.6848 78.6009 -10.9337 78.8508L-12.0215 79.9387C-12.147 80.0641 -12.3097 80.1258 -12.4735 80.1258ZM-8.22625 75.8797C-8.39001 75.8797 -8.55271 75.8169 -8.67713 75.6925C-8.92596 75.4437 -8.92596 75.0396 -8.67713 74.7897L-7.17349 73.2861C-6.92466 73.0372 -6.52056 73.0372 -6.27066 73.2861C-6.02183 73.5349 -6.02183 73.939 -6.27066 74.1889L-7.77431 75.6925C-7.89979 75.8169 -8.06355 75.8797 -8.22625 75.8797ZM-3.56432 71.2177C-3.72809 71.2177 -3.89079 71.155 -4.0152 71.0306C-4.26404 70.7818 -4.26404 70.3777 -4.0152 70.1278L-2.51156 68.6241C-2.26272 68.3753 -1.85863 68.3753 -1.60874 68.6241C-1.3599 68.873 -1.3599 69.2771 -1.60874 69.527L-3.11238 71.0306C-3.23786 71.155 -3.40162 71.2177 -3.56432 71.2177ZM1.09761 66.5558C0.933846 66.5558 0.771148 66.4931 0.64673 66.3687C0.397895 66.1198 0.397895 65.7157 0.64673 65.4658L2.15037 63.9622C2.39921 63.7134 2.8033 63.7134 3.0532 63.9622C3.30203 64.211 3.30203 64.6151 3.0532 64.865L1.54955 66.3687C1.42407 66.4931 1.26031 66.5558 1.09761 66.5558ZM5.75954 61.8939C5.59578 61.8939 5.43307 61.8311 5.30866 61.7067C5.05982 61.4579 5.05982 61.0538 5.30866 60.8039L6.8123 59.3003C7.06114 59.0514 7.46523 59.0514 7.71512 59.3003C7.96396 59.5491 7.96396 59.9532 7.71512 60.2031L6.21148 61.7067C6.086 61.8311 5.92224 61.8939 5.75954 61.8939ZM10.4215 57.232C10.2577 57.232 10.095 57.1692 9.97059 57.0448C9.72175 56.796 9.72175 56.3919 9.97059 56.142L11.4742 54.6383C11.7231 54.3895 12.1272 54.3895 12.3771 54.6383C12.6259 54.8872 12.6259 55.2913 12.3771 55.5412L10.8734 57.0448C10.7479 57.1692 10.5842 57.232 10.4215 57.232ZM15.0834 52.57C14.9196 52.57 14.7569 52.5073 14.6325 52.3829C14.3837 52.134 14.3837 51.7299 14.6325 51.48L16.1362 49.9764C16.385 49.7276 16.7891 49.7276 17.039 49.9764C17.2878 50.2252 17.2878 50.6293 17.039 50.8792L15.5353 52.3829C15.4099 52.5073 15.2461 52.57 15.0834 52.57ZM36.4407 50.456C36.2769 50.456 36.1142 50.3933 35.9898 50.2688L34.4861 48.7652C34.2373 48.5164 34.2373 48.1123 34.4861 47.8624C34.735 47.6135 35.1391 47.6135 35.389 47.8624L36.8926 49.366C37.1414 49.6149 37.1414 50.0189 36.8926 50.2688C36.7671 50.3933 36.6044 50.456 36.4407 50.456ZM19.7453 47.9081C19.5816 47.9081 19.4189 47.8454 19.2944 47.7209C19.0456 47.4721 19.0456 47.068 19.2944 46.8181L20.7981 45.3145C21.0469 45.0656 21.451 45.0656 21.7009 45.3145C21.9497 45.5633 21.9497 45.9674 21.7009 46.2173L20.1973 47.7209C20.0718 47.8454 19.9091 47.9081 19.7453 47.9081ZM31.7787 45.7941C31.615 45.7941 31.4523 45.7313 31.3278 45.6069L29.8242 44.1033C29.5754 43.8544 29.5754 43.4503 29.8242 43.2004C30.073 42.9516 30.4771 42.9516 30.727 43.2004L32.2307 44.7041C32.4795 44.9529 32.4795 45.357 32.2307 45.6069C32.1052 45.7313 31.9425 45.7941 31.7787 45.7941ZM24.4349 43.2749C24.2414 43.2749 24.05 43.1866 23.9245 43.0197C23.7129 42.7379 23.7692 42.338 24.051 42.1264C24.7114 41.6298 25.4962 41.3204 26.3203 41.231C26.6712 41.1928 26.9849 41.4458 27.0232 41.7968C27.0615 42.1466 26.8084 42.4614 26.4575 42.4997C25.862 42.5645 25.2941 42.7878 24.8177 43.1462C24.7029 43.2334 24.5678 43.2749 24.4349 43.2749Z",
    fill: "#AEB6FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_13751_185692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V104H47V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2626 101.448C6.01114 101.448 2.55298 97.9898 2.55298 93.7383C2.55298 89.4869 6.01114 86.0287 10.2626 86.0287C14.5141 86.0287 17.9722 89.4869 17.9722 93.7383C17.9722 97.9898 14.5141 101.448 10.2626 101.448ZM10.2626 87.3048C6.71511 87.3048 3.82905 90.1909 3.82905 93.7383C3.82905 97.2858 6.71511 100.172 10.2626 100.172C13.8101 100.172 16.6962 97.2858 16.6962 93.7383C16.6962 90.1909 13.8101 87.3048 10.2626 87.3048Z",
    fill: "#AEB6FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_13751_185692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V104H47V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1269 56.1612C41.9631 56.1612 41.8004 56.0985 41.676 55.9741L38.7219 53.02C38.4731 52.7711 38.4731 52.367 38.7219 52.1171C38.9707 51.8683 39.3748 51.8683 39.6247 52.1171L42.5788 55.0713C42.8277 55.3201 42.8277 55.7242 42.5788 55.9741C42.4534 56.0996 42.2907 56.1612 42.1269 56.1612Z",
    fill: "#AEB6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1728 56.1612C39.009 56.1612 38.8463 56.0985 38.7219 55.9741C38.4731 55.7252 38.4731 55.3212 38.7219 55.0713L41.676 52.1171C41.9249 51.8683 42.3289 51.8683 42.5788 52.1171C42.8277 52.366 42.8277 52.7701 42.5788 53.02L39.6247 55.9741C39.4992 56.0996 39.3355 56.1612 39.1728 56.1612Z",
    fill: "#AEB6FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_13751_185692",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 105
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H0V104H47V0Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2933 -3.61066L15.391 -2.70834L28.761 10.6617L29.6633 9.75937L16.2933 -3.61066Z",
    fill: "#AEB6FB"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13751_185692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H37C42.5229 0 47 4.47715 47 10V94C47 99.5229 42.5228 104 37 104H0V0Z",
    fill: "#AEB6FB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerMap);
export default __webpack_public_path__ + "static/media/partner-map.efba63173b685374d1486f9ea90ccfb7.svg";
export { ForwardRef as ReactComponent };